import { COLLECT_LOGIN_DETAILS, COLLECT_AUTH_LOGIN_DETAILS, VERIFY_DETAILS } from '../../../actions/eaTravelRates/auth';
import { loginService } from './login';
import { authLoginService } from './auth-login';
import { verifyService } from './verify';

import { TRIGGER_UPDATE_DETAILS, GET_EXCHANGE_LIST_DETAILS } from '../../../actions/eaTravelRates/update';
import { updateService } from './update';
import { exchangeListService } from './list';

export const eaTravelRates = (store, next, action) => {
    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_AUTH_LOGIN_DETAILS)) {
        return authLoginService(store, next, action);
    }

    if (action.type.startsWith(VERIFY_DETAILS)) {
        return verifyService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_UPDATE_DETAILS)) {
        return updateService(store, next, action);
    }

    if (action.type.startsWith(GET_EXCHANGE_LIST_DETAILS)) {
        return exchangeListService(store, next, action);
    }
};
